import moment from "moment-timezone";
import { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// constants
import { EARNINGS_DATA_TIMEZONE, TTimeFilterType } from "../../../../constants";
import { MOMENT_GRANULARITIES } from "../../constants";
// styles
import styles from "./styles.module.scss";
// utils
import getClasses from "utils/getClasses";
import getUSDollar from "utils/getUSDollar";

type Props = {
  x: number;
  y: number;
  width: number;
  height: number;
  value: number;
  filterType: TTimeFilterType;
  payload: {
    x: number;
  };
};

const TOOLTIP_OFFSET = 11;

const RoundedBar = ({
  x,
  y,
  width,
  height,
  value,
  filterType,
  payload,
  ...props
}: Props) => {
  const isFuture = useMemo(() => {
    const nowMoment = moment().tz(EARNINGS_DATA_TIMEZONE);

    return moment
      .tz(payload.x, EARNINGS_DATA_TIMEZONE)
      .isAfter(nowMoment.clone(), MOMENT_GRANULARITIES[filterType]);
  }, [filterType, payload]);

  return (
    <OverlayTrigger
      placement={"top"}
      overlay={
        <Tooltip
          id="rounded-bar-tooltip"
          className={styles["rounded-bar__tooltip"]}
        >
          {getUSDollar(value)}
        </Tooltip>
      }
    >
      <g transform={`translate(${x}, ${y})`}>
        <rect
          width={width}
          height={height || 1}
          rx="4"
          stroke="none"
          className={getClasses(
            styles["rounded-bar"],
            isFuture && styles["rounded-bar--future"],
          )}
        />
        {/* tooltip target */}
        <rect
          width={width}
          // for tooltip offset
          y={-TOOLTIP_OFFSET}
          // stacked on top of the bar
          height={TOOLTIP_OFFSET}
          fill="none"
        />
      </g>
    </OverlayTrigger>
  );
};

export default RoundedBar;
